export default __webpack_public_path__ + "static/media/banner_private_label_2.b018d034.jpg";